import React from 'react';
import { Bar } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { analyticsChartTheme } from 'util/chartUtils';
import CardBox from '../../../../components/kea/CardBox';
import DashboardStub from '../../../../components/kea/DashboardStub';
import IntlMessages from 'util/IntlMessages';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function AverageOrder({ aov }) {
  const t = useLocalizedMessage();
  const chartOptions = {
    legend: {
      display: false,
    },
    tooltips: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      xAxes: [{
        stacked: false,
      }],
      yAxes: [{
        stacked: false,
        ticks: {
          beginAtZero: true,
        },
      }],
    },
  };

  function prepareData(data) {
    return {
      labels: [t('recs.dashboard.aov.axis')],
      datasets: [
        {
          label: t('ui.recs.dashboard.aov.didnTUseRecommendations'),
          backgroundColor: analyticsChartTheme.clickRateFill,
          data: [data.noRecs],
          categoryPercentage: 0.9,
          barPercentage: 0.9,
        }, {
          label: t('ui.recs.dashboard.aov.usedRecommendations'),
          backgroundColor: analyticsChartTheme.brand,
          data: [data.recs],
          categoryPercentage: 0.9,
          barPercentage: 0.9,
        },
      ],
    };
  }

  if (aov.error) {
    return (
      <CardBox header={t('recs.dashboard.aov.title')} styleName="recs-dashboard-card">
        <DashboardStub />
      </CardBox>
    );
  }
  const chartData = prepareData(aov);

  return (
    <CardBox header={t('recs.dashboard.aov.title')} styleName="recs-dashboard-card">
      <div className="row">
        <div className="col-6">
          <Bar data={chartData} options={chartOptions} height={240} />
        </div>
        <div className="col-6">
          <p>
            <IntlMessages id="ui.recs.dashboard.aov.averageOrderValueAovForVisitorsWhoUsedRecommendationsIsHigher" />
            {' '}
            {aov.rate}
            %.
          </p>
        </div>
      </div>

    </CardBox>
  );
}

AverageOrder.propTypes = {
  aov: PropTypes.shape({
    rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    noRecs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    recs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    error: PropTypes.any,
  }).isRequired,
};

export default AverageOrder;
